import React from 'react';
import PropTypes from 'prop-types';
import ItemElement from '../ItemElement';
import HeaderIcon from './components/HeaderIcon';

export default class Review extends React.Component {
  render() {
    const {
      as,
      author,
      company,
      text,
      charLimit,
      image,
      cardInlinePhoto,
      imageCircular,
      imageSize,
      itemButtonFloat,
      itemCenterContent,
      link,
      linkAs,
      verticalItemAlign,
    } = this.props;

    return (
      <ItemElement
        as={as}
        header={author}
        headerIcon={
          link ? (
            <HeaderIcon
              link={link}
              showLink={linkAs !== 'header'}
              isVerticalItem={as === 'verticalItem'}
            />
          ) : null
        }
        subheader={company}
        content={text}
        charLimit={charLimit}
        image={image}
        cardInlinePhoto={cardInlinePhoto}
        imageCircular={imageCircular}
        imageSize={imageSize}
        itemButtonFloat={itemButtonFloat}
        itemCenterContent={itemCenterContent}
        link={link}
        linkAs={linkAs}
        verticalItemAlign={verticalItemAlign}
        event={{
          category: 'Reviews',
          action: 'click',
          label: 'See more',
        }}
      />
    );
  }
}

Review.propTypes = {
  text: PropTypes.string.isRequired,
  as: PropTypes.oneOf(['verticalItem', 'horizontalItem', 'card']),
  cardInlinePhoto: PropTypes.oneOf(['left', false]),
  charLimit: PropTypes.number,
  company: PropTypes.string,
  image: PropTypes.string,
  imageCircular: PropTypes.bool,
  imageSize: PropTypes.string,
  itemButtonFloat: PropTypes.oneOf(['left', 'right']),
  itemCenterContent: PropTypes.bool,
  link: PropTypes.string,
  linkAs: PropTypes.oneOf(['button', 'header', 'none']),
  author: PropTypes.string,
  verticalItemAlign: PropTypes.oneOf(['left', 'right', 'center']),
};

Review.defaultProps = {
  as: 'horizontalItem',
  cardInlinePhoto: false,
  charLimit: 280,
  company: '',
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  author: '',
  verticalItemAlign: 'center',
};
